import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { SUPPORTED_LANGUAGES_ARRAY } from '@src/constants';
import { getLocaleCodeBySubdomain } from '@src/helpers/host.helpers';

const API_KEY = import.meta.env.VITE_I18NEXUS_API_KEY;
const LOAD_PATH = `https://api.i18nexus.com/project_resources/translations/{{lng}}/{{ns}}.json?api_key=${API_KEY}`;

const localeCode = getLocaleCodeBySubdomain();

export const i18n = i18next.use(HttpBackend).use(initReactI18next);

i18n.init({
  fallbackLng: localeCode,
  ns: ['default', 'quiz'],
  defaultNS: 'quiz',
  supportedLngs: SUPPORTED_LANGUAGES_ARRAY,
  backend: { loadPath: LOAD_PATH },
});
